import { IWidthSetAction } from './types';
import { AT_WIDTH_SET } from './constants';

export const widthSetAction = (
    width: number
): IWidthSetAction => ({
    type: AT_WIDTH_SET,
    width
});
